module.exports = __webpack_public_path__ + "img/shenhe_gzh.de378bbe.png";